import { Vue, i18n } from 'Common/vue';

// import components
import Minicart from './../components/src/Minicart.vue'
import '../components/toggle';

import './navigation';
import { checkResolution } from '../tools/helpers';
import { StickyScrollingHeader } from './sticky-srcolling-header';

// new vue instance
if (document.querySelector('.vue-autocomplete').classList.contains('has-luigis-box')) {
    import('./../components/src/LuigisAutocomplete.vue').then(({ default: LuigisAutocomplete }) => {
        window.$_autocomplete = new Vue({
            i18n,
            render: h => h(LuigisAutocomplete, {
                props: {
                    luigisBoxPublicKey: document.querySelector('.vue-autocomplete').dataset.luigisBoxPublicKey,
                    texts: JSON.parse(document.querySelector('.vue-autocomplete').dataset.texts),
                }
            })
        }).$mount(".vue-autocomplete");
    })
} else {
    import('./../components/src/Autocomplete.vue').then(({ default: Autocomplete }) => {
        window.$_autocomplete = new Vue({
            i18n,
            render: h => h(Autocomplete)
        }).$mount(".vue-autocomplete");
    })
}

window.$_minicart = new Vue({
    i18n,
    render: h => h(Minicart)
}).$mount("#minicart");

const headerEl = document.querySelector('.js-page-header')
const headerTopHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-top-height')) || 40
const headerStuckLinksEL = document.querySelector('.js-header-stuck-links')
const headerWishlistEL = document.querySelector('.js-header-wishlist')

function stickHeaderOnScroll() {
    const headerSearchEL = document.querySelector('.js-header-search')
    const isCurrentlyStuck = headerEl.classList.contains('is-stuck')
    const isAboutToBeStuck = window.scrollY > (isCurrentlyStuck ? 0 : headerTopHeight)

    headerEl.classList.toggle('is-stuck', checkResolution('sm;md;lg') && isAboutToBeStuck)

    if (headerSearchEL) {
        headerSearchEL.style.width = ``

        if (checkResolution('md;lg') && isAboutToBeStuck) {
            headerSearchEL.style.width = `${headerSearchEL.offsetWidth - headerStuckLinksEL.offsetWidth + headerWishlistEL.offsetWidth - 20}px`
        }
    }

    if (isAboutToBeStuck !== isCurrentlyStuck) {
        const event = new CustomEvent('stick-change', {
            detail: {
                isStuck: isAboutToBeStuck
            },
            cancelable: false
        })

        headerEl.dispatchEvent(event)
    }
}

window.addEventListener('scroll', stickHeaderOnScroll)

if (window.scrollY >= headerTopHeight) {
    stickHeaderOnScroll()
}

const pageHeaderEl = document.querySelector('.js-page-header')
if (pageHeaderEl) {
    pageHeaderEl.stickyScrollingHeader = new StickyScrollingHeader('.js-page-header')
}